module.exports = require('../index.js')


/** WEBPACK FOOTER **
 ** ./_site/_bundle.js
 **/